"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getAugBoxesToOneImage_1 = __importDefault(require("../getAugBoxesToOneImage"));
var createImageServiceURL = function (domain, adId, urlInternalId) {
    return "/ads/".concat(domain, "/").concat(adId, "/image/").concat(urlInternalId);
};
var isImageInfoValid = function (imageInfo) {
    return (imageInfo && imageInfo.crawlingStatus === 'success' && imageInfo.urlInternalId && imageInfo.width > 0 && imageInfo.height > 0);
};
var addInfoToImages = function (images, domain, adId, imagesInfoContent, imageAug) {
    // add info to images
    // Remember to remove them in getDecisionData, so they won't be sent to clients.
    var imagesWithInfos = images.map(function (image) {
        var _a;
        var matchedImageInfo = imagesInfoContent === null || imagesInfoContent === void 0 ? void 0 : imagesInfoContent.find(function (info) { return info.url === image.src; });
        if (!isImageInfoValid(matchedImageInfo)) {
            return image;
        }
        // This if statement is add in ts part not sure if it's needed
        if (matchedImageInfo) {
            var matchedImageAug = imageAug === null || imageAug === void 0 ? void 0 : imageAug.find(function (imageAugItem) { return imageAugItem.urlInternalId === matchedImageInfo.urlInternalId; });
            return __assign(__assign(__assign({}, image), { imageServiceUrl: createImageServiceURL(domain, adId, matchedImageInfo.urlInternalId), originalSize: { width: matchedImageInfo === null || matchedImageInfo === void 0 ? void 0 : matchedImageInfo.width, height: matchedImageInfo.height }, phash: (_a = matchedImageInfo === null || matchedImageInfo === void 0 ? void 0 : matchedImageInfo.phash) === null || _a === void 0 ? void 0 : _a.value }), (matchedImageAug && { augBoxes: (0, getAugBoxesToOneImage_1.default)(matchedImageAug) }));
        }
        return image;
    });
    return imagesWithInfos;
};
exports.default = addInfoToImages;
